module.exports = __webpack_public_path__ + "img/Zenefits.3aa764af.svg";